import { useMemo, useState } from 'react'
import { eligibleOwnedOils, layerOptionState, toggleLayerOptionSelection } from '../../lib/layeringPicker'

export default function OwnedOilSelector({ anchor, collection = [], selected = [], onSelectedChange }) {
  const [open, setOpen] = useState(false)
  const oils = useMemo(() => eligibleOwnedOils(collection, anchor?.id), [collection, anchor?.id])

  return (
    <section className="mt-4 rounded-xl border border-gold/20 bg-gold/[0.04] p-3" data-owned-oil-selector>
      <button
        type="button"
        aria-expanded={open}
        onClick={() => setOpen(value => !value)}
        className="flex min-h-11 w-full items-center justify-between gap-3 text-left text-sm font-semibold text-gold"
      >
        <span>Select an Oil</span>
        <span aria-hidden="true">{open ? '−' : '+'}</span>
      </button>
      {open && (
        <div className="mt-2 border-t border-gold/15 pt-2" data-owned-oil-options>
          {oils.length === 0 ? (
            <p className="py-2 text-xs text-cream/40">No eligible owned oils are available for this layer set.</p>
          ) : oils.map(oil => {
            const state = layerOptionState({ option: oil, anchor, selected })
            return (
              <button
                key={oil.id}
                type="button"
                disabled={state.disabled}
                aria-pressed={state.selected}
                data-owned-oil-id={oil.id}
                data-collection-row-id={oil.id}
                onClick={() => {
                  const next = toggleLayerOptionSelection({ option: oil, anchor, selected })
                  if (next !== selected) onSelectedChange?.(next)
                }}
                className={`block min-h-11 w-full border-b border-white/5 px-2 py-2 text-left last:border-b-0 ${state.disabled ? 'cursor-not-allowed text-cream/25' : state.selected ? 'bg-gold/10 text-gold' : 'text-cream/75 hover:bg-white/5'}`}
              >
                <span className="block text-sm font-semibold">{oil.name}</span>
                <span className="block text-[11px] text-cream/40">{oil.house}{oil.concentration ? ` · ${oil.concentration}` : ''}</span>
                {state.reason && <span className="mt-1 block text-[11px] text-amber-200" role="note">{state.reason}</span>}
              </button>
            )
          })}
        </div>
      )}
    </section>
  )
}
